module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/tea-icon-1bde6d21bbf43524e34bd37a4f6cf9da.png";